import {
  SET_PARAMS_COMPOSER_AUTHOR,
  CLEAR_PARAMS_COMPOSER_AUTHOR,
  SET_BULK_PARAMS_COMPOSER_AUTHOR,
} from "constants/types";

const initialState = {
  search: "",
  page: 1,
  size: 10,
  original_publisher_id: 0,
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_PARAMS_COMPOSER_AUTHOR:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case SET_BULK_PARAMS_COMPOSER_AUTHOR:
      return {
        ...state,
        ...payload, // Make sure payload contains valid keys like `search` or `page`
      };
    case CLEAR_PARAMS_COMPOSER_AUTHOR:
      return {
        ...state,
        search: "",
        page: 1,
      };
    default:
      return state;
  }
}
